// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/original-f417e9077c877f2e552b7af673fb21a0.jpg",
    title: "Food Website",
    description:
      "A cross-platform Food Website (in closed testing) where one can order different type o food.",
    tech_stack: ["React Native", "Google Cloud", "NextJs", "TailwindCSS"],
    github_url: "https://github.com/yogeshrwat",
    demo_url: "https://food-website-alpha-sage.vercel.app/",
  },
  {
    img: "/renr-responsive.png",
    title: "RENR Safety App",
    description:
      "A safety application for the Renewable Resources Dept. of BCA",
    tech_stack: ["React", "Firebase"],
    github_url: "https://github.com/yogeshrwat",
    demo_url: "https://renr-bcit.web.app/",
  },
  {
    img: "/mymind-responsive.png",
    title: "MyMind",
    description:
      "An app where users can purchase online therapy sessions and chat with their therapists.",
    tech_stack: ["HTML", "CSS", "NodeJs", "MongoDB", "SocketIo"],
    github_url: "https://github.com/yogeshrwat",
    demo_url: "https://mymindweb.vercel.app/",
  },
  {
    img: "/1 q9ytuylJQXMP-FaxjQyA1Q.jpg",
    title: "Todo list",
    description:
      "A to-do list is a simple organizational tool that outlines tasks and activities that need to be completed, typically prioritized by importance or urgency. It helps individuals manage their time, stay organized, and ensure that important responsibilities are not overlooked.",

    tech_stack: ["NextJs", "NodeJs"],
    github_url: "https://github.com/yogeshrwat",
    demo_url: "https://todo-list-theta-three-27.vercel.app/",
  },
  {
    img: "/web-design-editor-8118404-6525848.webp",
    title: "3D Portfolio Website",
    description:
      "A 3D portfolio website made in React is a digital showcase for an individual's work, featuring interactive 3D elements and animations. Built using the React JavaScript library, it allows for dynamic user interfaces and responsive design, providing an engaging and visually appealing experience for visitors.",
    tech_stack: ["ThreeJs", "React", "NodeJs", "Emailjs"],
    github_url: "https://github.com/yogeshrwat",
    demo_url: "https://yogeshrwat.github.io/portfolio/#about",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
    name: "NextJs",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "Typescript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "React Native",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
    name: "Firebase",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
    name: "Flask",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    name: "Java",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    name: "Material UI",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-plain.svg",
    name: "TailwindCSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
];
